import b_ from 'b_';
import React, {PureComponent} from 'react';

import {Gap} from '#blocks/types';
import './Col.styl';

export interface ColProps<T = HTMLDivElement> extends React.HTMLProps<T> {
    innerRef?: React.Ref<T>;
    grow?: boolean;
    gap?: Gap;
    width?: 's' | 'm' | 'l' | 'xl';
    shrink?: boolean;
}

const b = b_.with('ColSupport');

class Col extends PureComponent<ColProps> {
    public render() {
        const {
            innerRef,
            grow = false,
            gap = false,
            width = false,
            className,
            shrink = false,
            ...restProps
        } = this.props;
        const colClassName = [b({gap, shrink, grow, width}), className]
            .filter(Boolean)
            .join(' ');

        return (
            <div
                {...restProps}
                className={colClassName}
                ref={innerRef}/>
        );
    }
}

export default Col;
